<nb-card class="dialog-modal-card">
    <nb-card-header>{{ title }}</nb-card-header>
    <nb-card-body>
        <div [innerHTML]="body"></div>
    </nb-card-body>
    <nb-card-footer>
        <button nbButton status="success" (click)="dismiss()">OK</button>
    </nb-card-footer>
</nb-card>